export default __webpack_public_path__ + "static/media/spotify.ff0af4c7.png";